import { createSelector } from 'reselect'

export const getSimilarProducts = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.detail && state.vehicleParts.detail.similarProducts &&
    Array.isArray(state.vehicleParts.detail.similarProducts.elements) ? state.vehicleParts.detail.similarProducts.elements : [],
  similarProducts => similarProducts
)
